// extracted by mini-css-extract-plugin
module.exports =  {"summaryTableRenderer":"summaryTableRenderer__NfB-8"};